module.exports = __webpack_public_path__ + "static/media/paxel.a253935b.png";